import React from "react";

/**
 * Colour-codes an overall PSEA rating. Ratings are now the automated capacity
 * bands (Full / Medium / Low); the older "meets requirements" wording is still
 * matched so historical records keep their colour.
 */
export const ratingTone = (rating?: string) => {
  const value = (rating || "").toLowerCase();
  if (value.includes("full")) return "success";
  if (value.includes("medium") || value.includes("partially")) return "warning";
  if (
    value.includes("low") ||
    value.includes("does not") ||
    value.includes("not meet")
  )
    return "danger";
  return "secondary";
};

const PSEARatingBadge = ({ rating }: { rating?: string }) => {
  if (!rating) return <span className="text-muted">-</span>;
  const tone = ratingTone(rating);
  return (
    <span
      className={`badge rounded-pill bg-${tone}-subtle text-${tone} fs-12 fw-medium d-inline-flex align-items-center gap-1`}
    >
      <i
        className="ri-checkbox-blank-circle-fill"
        style={{ fontSize: "7px" }}
      ></i>
      {rating}
    </span>
  );
};

export default PSEARatingBadge;
